export const TOGGLE_MOBILE_MENU = 'TOGGLE_MOBILE_MENU';
export const CHANGE_OPEN_ACCORDION = 'CHANGE_OPEN_ACCORDION';
export const CHANGE_SECOND_OPEN_ACCORDION = 'CHANGE_SECOND_OPEN_ACCORDION';
export const SET_BREADCRUMB_TO_VISIBLE = 'SET_BREADCRUMB_TO_VISIBLE';
export const REMOVE_BREADCRUMB_VISIBLE_STATE = 'REMOVE_BREADCRUMB_VISIBLE_STATE';
export const SET_UNDERLINE_MENU_ITEM = 'SET_UNDERLINE_MENU_ITEM';
